import React from 'react';
import style from './LeftSide.module.scss';
import Close from "../../image/icon/cloose.png";
import Zhonghe from "../../image/temp/zhonghe.jpg";
import Taobao from "../../image/temp/taobao.png";
import Alibaba from "../../image/temp/alibaba.png";
import $ from  'jquery';
class LeftSide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        data:null,
        about_us_en:"",
        about_us_ch:"",
        firstOpen:false
    }
  }
  componentDidMount() {
      this.setState({
          firstOpen:true
      })
      var that=this;
      $.ajax({
          type:'get',
          url:'/home/home.json',
          success:function (data) {
              that.setState({
                  data:data,
                  about_us_en:data.leftSide.about_us_en,
                  about_us_ch:data.leftSide.about_us_ch
              })
          }
      })
  }
closeState=()=>{
      this.props.close();
}
  render() {
    return (
            <div className={this.props.leftState?style.leftSide_show+" "+style.leftSide:style.leftSide+" "+style.leftSide_hidden}>
                {console.log(this.props.leftState)}
                <img className={style.close} src={Close} alt="" onClick={(e)=>this.closeState(e)}/>
                <div className={style.info_container}>
                    <div className={style.left}>
                        <div className={style.title}>about us</div>
                        <div className={style.intro}>{this.state.about_us_en}</div>
                    </div>
                    <div className={style.right}>
                        <div className={style.title}>关于我们</div>
                        <div className={style.intro}>{this.state.about_us_ch}</div>
                        <div className={style.more}>MORE -></div>
                        <div className={style.qrcode_wrap}>
                            <img src={Zhonghe}></img>
                            <img src={Taobao}></img>
                            <img src={Alibaba}></img>
                        </div>
                    </div>
                </div>
            </div>
    );
  }

}
export default LeftSide;
